type UrlLink = { url?: string | null; name?: string | null };

const HTML_TAG = /<\/?[a-zA-Z][^>]*>/g;
const HTML_ENTITIES: Array<[RegExp, string]> = [
    [/&nbsp;/gi, ' '],
    [/&amp;/g, '&'],
    [/&lt;/g, '<'],
    [/&gt;/g, '>'],
    [/&quot;/g, '"'],
    [/&#39;|&apos;/g, "'"],
];

const stripHtml = (input: string): string => {
    let out = input
        .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
        .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/<\/(?:p|li|div|tr|h[1-6])>/gi, ' ')
        .replace(HTML_TAG, '');
    for (const [pattern, replacement] of HTML_ENTITIES) {
        out = out.replace(pattern, replacement);
    }
    return out;
};

// Stray "Â" appears when Windows-1252 bytes (often the U+00A0 non-breaking
// space) are decoded as Latin-1 and re-encoded as UTF-8. Strip the standalone
// character; whitespace collapsing tidies the result.
const stripMojibake = (input: string): string => input.replace(/Â/g, '');

export const sanitiseExportText = (value: string | null | undefined): string => {
    if (!value) return '';
    return stripMojibake(stripHtml(value)).replace(/\r?\n/g, ' ').replace(/\s+/g, ' ').trim();
};

const asLinkArray = (value: unknown): UrlLink[] =>
    Array.isArray(value) ? (value as UrlLink[]).filter((link): link is UrlLink => link != null) : [];

// Returns parallel arrays so callers can emit one row per index in a
// transposed CSV. Empty entries are preserved positionally so URL and Name
// stay aligned.
export const splitUrlLinkArray = (value: unknown): { names: string[]; urls: string[] } => {
    const links = asLinkArray(value);
    if (links.length === 0) return { names: [], urls: [] };
    return {
        names: links.map((link) => sanitiseExportText(link.name ?? '')),
        urls: links.map((link) => (link.url ?? '').trim()),
    };
};
